export type StackGap = "sm" | "md" | "lg";

/**
 * Vertical flex stack for consistent spacing between blocks.
 *
 * @param options - Gap size token mapped to **`qz-stack--*`**.
 * @returns Empty stack element; append children in order.
 */
export function createStack(
  options?: Readonly<{ gap?: StackGap }>,
): HTMLDivElement {
  const el = document.createElement("div");
  const gap = options?.gap ?? "md";
  el.className = `qz-stack qz-stack--gap-${gap}`;
  return el;
}
